import React, { useState, useEffect } from "react";
import Wrapper from "../Components/Wrapper";
import { useContext } from "react";
import { MemoryLevelContext } from "../Context/MemoryLevelContext";
import MemoryGameHeading from "./MemoryGameHeading";
import PlayAgainButton from "../Components/PlayAgainButton";
import MemoryNextStageButton from "./MemoryNextStageButton";
import MemoryNextLevelButton from "./MemoryNextLevelButton";

const MemoryConclusion = () => {
    //Context
    const {levels, levelList, memoryCards, memoryCompleted} = useContext(MemoryLevelContext);

    //Local states
    const [seeConclusion, setSeeConclusion] = useState(false);
    const [nextStage, setNextStage] = useState({});
    const [nextLevel, setNextLevel] = useState({});
    const [levelDone, setLevelDone] = useState(false);
    const [allLevelsDone, setAllLevelsDone] = useState(false);

    //substages of current level
    const currentSubStages = levelList.filter(level => level.stageId == levels.level.level).map(level => level.subStages).flat();

    // reduces memoryCards array and match cardObjects that have matching cardIds into a big object with 2d array
    const reducedMemoryCards = memoryCards.reduce((previous, currentCard) => ({
         ...previous, 
         [currentCard.cardId]: [...(previous[currentCard.cardId] || []), currentCard] }), 
         {});
    const reducedMemoryCardsValues = Object.values(reducedMemoryCards);
    

    // check if next memory is next stage of current level or new level
    useEffect(() => {
        if(memoryCompleted){
            setTimeout(() => {setSeeConclusion(true)}, 10);
        }

        if(levels.stage.stage < 3 && currentSubStages.length === 3){
            setNextStage(currentSubStages.find(stage => stage.stageId == (levels.stage.stage + 1)));
        } else if(levels.stage.stage < 2 && currentSubStages.length === 2 ){
            setNextStage(currentSubStages.find(stage => stage.stageId == (levels.stage.stage + 1)));
        }else if(levels.stage.stage < 3 && currentSubStages.length === 2){
            setNextLevel(levelList.find(level => level.stageId == (levels.level.level + 1)));
            setLevelDone(true);
        } else if(levels.stage.stage < 2 && currentSubStages.length === 1){
            setNextLevel(levelList.find(level => level.stageId == (levels.level.level + 1)));
            setLevelDone(true);
        } else if(levels.level.level < 3 && levelList.length > 1) {
            setNextLevel(levelList.find(level => level.stageId == (levels.level.level + 1)));
            setLevelDone(true);
        } else{
            setAllLevelsDone(true);
        }

    }, [memoryCompleted]);

    useEffect(() => {
        scrollTo(0,0);
    }, []);

    return(
        <div className={`memory-fourth-page ${seeConclusion ? "open": ""}`}>
            <Wrapper>
                <MemoryGameHeading />
                <div className="memory-game-conclusion">
                    <h2>Facit</h2>
                    <div className="memory-game-conclusion__grid">
                        {reducedMemoryCardsValues.map((pairs, index) => {
                        return (<div key={index} className="memory-game-conclusion__pair">
                                    <div className="memory-game-conclusion__pair__images">
                                        {pairs.map(card => {
                                            return <img key={card.keyId} className="memory-game-conclusion__pair__images__image" src={`https://${card.image}?format=webp&quality=70&width=100&height=150`} />
                                        })}
                                    </div>
                                    <div className="memory-game-conclusion__pair__text">
                                        <div className="memory-game-conclusion__pair__text__heading">
                                            {pairs.map((card, index) => {
                                                return (
                                                <span key={index}>{card.name} {index < 1 ? "&" : ""} </span>
                                                );
                                            })}
                                        </div>
                                        {pairs[0]?.description && 
                                            <p>{pairs[0].description}</p>
                                        }
                                    </div>
                                </div>)
                        })}
                    </div>
                </div>
                 <div className="play-again-buttons-container">
                    <PlayAgainButton />
                    {!allLevelsDone && nextStage != null && nextLevel != null &&
                     <>
                        {levelDone ?
                            <MemoryNextLevelButton nextLevel={nextLevel} />
                        :
                            <MemoryNextStageButton nextStage={nextStage} />
                        }
                    </>
                    }
                </div>
            </Wrapper>
        </div>
    );
};

export default MemoryConclusion;